import { takeLatest, delay, put } from 'redux-saga/effects'

import { MESSAGE_SET_MESSAGE } from '../actions/constants'
import { hideMessage } from '../actions/message'

function* handleShowMessage() {
  yield delay(5000)
  yield put(hideMessage())
}

export function* messageWatcher() {
  yield takeLatest(MESSAGE_SET_MESSAGE, handleShowMessage)
}
